module.exports = __webpack_public_path__ + "assets/img/illustration6.5bccb265.svg";